import * as types from './studentFinancialSupport.types'

const initialState = {
	isLoading: false,
	isSuccess: false,
	studentFinancialSupport: {
		financial_support_type_id: null,
		access_participation_flag_id: null,
		financial_support_amount: null,
	},
	options: {},
	canBeCreatedStudentFinancialSupport: false,
	permissions: {},
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.TOGGLE_LOADING:
			return {
				...state,
				isLoading: payload,
			}
		case types.SET_STUDENT_FINANCIAL_SUPPORT:
			return {
				...state,
				studentFinancialSupport: payload,
			}
		case types.TOGGLE_SUCCESS:
			return {
				...state,
				isSuccess: payload,
			}
		case types.SET_OPTIONS:
			return {
				...state,
				options: payload,
			}
		case types.CLEAR_DATA:
			return {
				...state,
				studentFinancialSupport: initialState.studentFinancialSupport,
			}
		case types.SET_PERMISSIONS:
			return {
				...state,
				permissions: payload,
			}
		case types.SET_CAN_BE_CREATED:
			return {
				...state,
				canBeCreatedStudentFinancialSupport: payload,
			}
		default:
			return state
	}
}
